<template>
  <div class="sidebar">
    <router-link to="/superadmin" style="text-decoration:none">
      <svg
        v-if="isDefaultLogo.length && isDefaultLogo[1].value.status"
        xmlns="http://www.w3.org/2000/svg"
        width="167.29"
        height="40.891"
        viewBox="0 0 167.29 40.891"
      >
        <g transform="translate(0 0)">
          <path
            d="M207,62.549v-7.43h-8.826v7.43H195.2V45.58h2.977V52.5H207V45.58h2.977V62.549Z"
            transform="translate(-144.631 -33.772)"
            fill="#07143d"
          />
          <path
            d="M263.05,68.905a6.208,6.208,0,0,1,6.233-6.435c3.686,0,6.028,2.8,6.028,6.666V69.8h-9.464a3.714,3.714,0,0,0,3.886,3.383,5.166,5.166,0,0,0,3.51-1.373l1.223,1.754a7.273,7.273,0,0,1-4.987,1.813A6.17,6.17,0,0,1,263.05,68.905Zm6.218-4.246a3.361,3.361,0,0,0-3.435,3.231h6.92a3.322,3.322,0,0,0-3.5-3.231Z"
            transform="translate(-194.903 -46.286)"
            fill="#07143d"
          />
          <path
            d="M326.081,75.063v-1.35a5.163,5.163,0,0,1-3.992,1.653,4.09,4.09,0,0,1-4.249-4.07,3.94,3.94,0,0,1,4.249-4.018,5.127,5.127,0,0,1,3.992,1.578V67.024c0-1.425-1.194-2.29-2.873-2.29a4.922,4.922,0,0,0-3.627,1.578l-1.119-1.857a7.2,7.2,0,0,1,5.163-1.984c2.746,0,5.137,1.145,5.137,4.427v8.166Zm0-2.8V70.379a3.663,3.663,0,0,0-2.925-1.272,2.249,2.249,0,1,0,0,4.427A3.654,3.654,0,0,0,326.081,72.265Z"
            transform="translate(-235.499 -46.286)"
            fill="#07143d"
          />
          <path
            d="M379.863,62.549V60.87a4.938,4.938,0,0,1-3.943,1.982c-3.129,0-5.44-2.391-5.44-6.461,0-3.966,2.29-6.435,5.44-6.435a4.787,4.787,0,0,1,3.943,2.01V45.58h2.668V62.549Zm0-3.715V53.979a3.984,3.984,0,0,0-3.153-1.655c-2.137,0-3.487,1.7-3.487,4.07s1.35,4.1,3.487,4.1A3.99,3.99,0,0,0,379.863,58.834Z"
            transform="translate(-274.502 -33.772)"
            fill="#07143d"
          />
          <path
            d="M430.37,75.1V62.813h2.671v1.78a5.318,5.318,0,0,1,3.992-2.073v2.632a3.78,3.78,0,0,0-.813-.075,4.187,4.187,0,0,0-3.179,1.653V75.1Z"
            transform="translate(-318.877 -46.323)"
            fill="#07143d"
          />
          <path
            d="M461.59,68.905a6.31,6.31,0,1,1,6.308,6.461A6.121,6.121,0,0,1,461.59,68.905Zm9.844,0c0-2.161-1.246-4.07-3.536-4.07s-3.536,1.917-3.536,4.07S465.634,73,467.9,73,471.434,71.094,471.434,68.905Z"
            transform="translate(-342.009 -46.286)"
            fill="#07143d"
          />
          <path
            d="M518,68.905a6.311,6.311,0,1,1,6.308,6.461A6.121,6.121,0,0,1,518,68.905Zm9.844,0c0-2.153-1.259-4.07-3.549-4.07s-3.534,1.917-3.534,4.07S522.034,73,524.3,73,527.844,71.094,527.844,68.905Z"
            transform="translate(-383.805 -46.286)"
            fill="#07143d"
          />
          <path
            d="M592.245,75.063V67.05c0-1.324-.586-2.215-2.036-2.215a3.66,3.66,0,0,0-2.85,1.63v8.6h-2.668V67.05c0-1.324-.56-2.215-2.01-2.215a3.767,3.767,0,0,0-2.85,1.63v8.6H577.16V62.776h2.671v1.645a5.44,5.44,0,0,1,4.023-1.951,3.232,3.232,0,0,1,3.368,2.238,5.181,5.181,0,0,1,4.171-2.238c2.238,0,3.536,1.22,3.536,3.715v8.878Z"
            transform="translate(-427.639 -46.286)"
            fill="#07143d"
          />
          <path
            d="M37.38,13.94V26.974a7.422,7.422,0,0,1-3.7,6.427l-3.751,2.166v-21.6L22.422,9.635V18.29l-7.464-4.3V1h0a7.425,7.425,0,0,1,7.425,0l11.3,6.518A7.422,7.422,0,0,1,37.38,13.94ZM14.958,22.6v8.655L7.464,26.927V5.321L3.712,7.487A7.422,7.422,0,0,0,0,13.917V26.943A7.42,7.42,0,0,0,3.713,33.37L15,39.9a7.425,7.425,0,0,0,7.425,0h0V26.909Z"
            transform="translate(0 0)"
            :fill="primary"
          />
        </g>
      </svg>
      <img
        v-else-if="isDefaultLogo.length > 0"
        :src="isDefaultLogo[0].value.image"
        style="width: 100%; height: 50px; border-radius: 5px;"
        alt=""
      />
      <img v-else src="@/assets/media/brand.svg" alt="QSpace Logo" />
    </router-link>
    <ul class="menu--list">
      <li class="menu--list-item has-actions">
        <router-link ref="listItem" to="/superadmin/">Tenants</router-link>
        <div class="list-action">
          <ActionButton
            :theme="{ primary, secondary, event, danger }"
            label="+"
            @customEvent="
              handleAddClick({
                modal: `superadmin-${$route.matched[1].name}-add-tenant`,
                path: 'add-tenant',
                name: 'add-tenant'
              })
            "
          />
        </div>
      </li>
    </ul>
    <div class="sidebar--footer">
      <router-link
        to="/superadmin/logs"
        class="footer-link"
        :style="{ color: primary }"
        >Activity</router-link
      >
      <a
        class="footer-link"
        :style="{ color: primary }"
        @click="
          handleAddClick({
            modal: `superadmin-${$route.matched[1].name}-report-bug`,
            path: 'report-bug',
            name: 'report-bug'
          })
        "
        >Report an Issue</a
      >
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import { setTimeout } from "timers";
import _ from "lodash";
export default {
  name: "Sidebar",
  components: {
    ActionButton
  },
  data() {
    return {
      isDefaultLogo: [
        {
          value: {
            image: null
          }
        },
        {
          value: {
            status: false
          }
        }
      ],
      isConciergeLogoMain: [
        {
          value: {
            image: null
          }
        }
      ],
      isConciergeLogs: [
        {
          value: {
            status: false
          }
        }
      ],
      isConciergeLogoSub: [
        {
          value: {
            image: null
          }
        }
      ]
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  watch: {
    primary: function() {
      this.chekcActiveLinks();
    },
    $route() {
      this.chekcActiveLinks();
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions");
    this.isDefaultLogo = this.options;

    let filterLogo = {
      key: "defaultlogo.main"
    };
    this.isConciergeLogoMain = _.filter(this.options, filterLogo);
    let filterLogoSub = {
      key: "defaultlogo.sub"
    };
    this.isConciergeLogoSub = _.filter(this.options, filterLogoSub);
    let conciergeFilterLogs = {
      key: "concierge.logs"
    };
    this.isConciergeLogs = _.filter(this.options, conciergeFilterLogs);
  },
  mounted() {
    this.chekcActiveLinks();
  },
  methods: {
    handleAddClick(params) {
      this.$emit("modalClicked", params);
    },
    handleShowAllClick() {
      this.$router.push({ path: "/superadmin/" });
    },
    chekcActiveLinks() {
      const listItem = document.querySelectorAll(".menu--list-item a");

      setTimeout(() => {
        [...listItem].map(e => {
          if (e.classList.contains("router-link-active")) {
            e.style.color = this.primary;
          } else {
            e.style.color = "#232323";
          }
        });
      }, 50);
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;
  position: relative;
  font-family: "Gotham", sans-serif;
  .icon--brand {
    color: $brand-primary;
    display: block;
    fill: currentColor;
    height: 2.5rem;
    stroke: currentColor;
    stroke-width: 0;
    width: 8rem;
  }
  .bookings-today {
    &--wrapper {
      margin-top: 35px;
      padding: 20px;
      position: relative;
      & > svg {
        position: absolute;
        right: 2px;
        top: 0;
      }
      & > h5 {
        color: $brand-primary;
        font-size: $font-size-sm;
        & > span {
          display: block;
          font-size: $font-size-xl;
          margin-bottom: 10px;
        }
      }
    }
  }
  .menu--list {
    list-style-type: none;
    margin-top: 30px;
    padding: 0;
    &-item {
      font-size: $font-size-sm;
      margin-bottom: 25px;
      position: relative;
      &.list-part {
        margin-top: 40px;
      }
      a {
        color: $gray-900;
        font-family: "Gotham";
        font-weight: 500;
        &.router-link-active {
          color: $brand-primary;
        }
      }
      &.has-actions {
        .list-action {
          border-left: 1px solid $gray-200;
          display: flex;
          padding-left: 15px;
          position: absolute;
          right: -8px;
          top: 0;
          button {
            height: 25px;
            margin-top: 0;
            padding: 0;
            width: 25px;
            &:first-child {
              margin-right: 15px;
            }
          }
        }
      }
      .submenu--list {
        list-style-type: none;
        padding-left: 15px;
        li {
          margin-top: 20px;
          a {
            color: $gray-700;
            font-size: $font-size-xs;
            &.router-link-active {
              color: $brand-primary;
            }
          }
        }
      }
    }
  }
  &--footer {
    bottom: 0;
    display: flex;
    padding: 5px 0;
    position: absolute;
    width: 100%;
    @media (max-height: 660pxx) {
      position: relative;
    }
    .footer-link {
      color: $brand-primary;
      font-size: $font-size-sm;
      position: relative;
      &:first-child {
        &:after {
          color: $gray-200;
          content: "|";
          position: absolute;
          right: -13px;
        }
      }
      &:last-child {
        cursor: pointer;
        position: absolute;
        right: 0;
        &:hover {
          color: $brand-primary;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
